import { BRAND } from "../../constants/brand";
import { Row, Col, Select, Button, Tag } from "antd";
import styles from "./index.module.scss";
import MainLayout from "../../components/layout/main-layout";
import bannerImage3 from "../../assets/imrpintbannernew.png";
import { useState } from "react";

const NewsData = [
  {
    id: 1,
    title: "From incubation to scale up - {BRAND.domainLabel}, a UK tech startup...",
    date: "4 Jun 2025",
    readTime: "15 mins read",
    category: "News",
    image: "/Images/incubation.png",
    description: (
      <p>
        {BRAND.domainLabel} is a UK tech startup which presents an alternative future
        for social networking...
      </p>
    ),
    slug: "incubation",
  },
  {
    id: 2,
    title:
      "{BRAND.short} is born - the origin story {BRAND.short} is born in the first Unfollow Series Graphic novel as it is being written. This was published April 2024 - The app and graphic novels are the beginning of a movement and rebellion for a safer space online.",
    date: "6 March 2023",
    readTime: "12 mins read",
    category: "News",
    image: "/Images/donates.png",
    description: (
      <p>
        {BRAND.domainLabel} came to life through The Buddyhood's debut novel in The
        Unfollow Series, <em>The Dark Side</em>...
      </p>
    ),
    slug: "imprint-born",
  },
  {
    id: 3,
    title:
      "{BRAND.product} partners with Folio3 AI to create a values-based social media platform, which will be at the forefront of online safety.",
    date: "December 2023",
    readTime: "8 mins read",
    category: "News",
    image: "/Images/creators.png",
    description: (
      <p>
        In December 2023, {BRAND.domainLabel} partnered with Folio3 AI to create a
        values-driven social media...
      </p>
    ),
    slug: "imprint-partners",
  },
  {
    id: 4,
    title:
      "{BRAND.short} brings on Modsquad as human moderators who are at the forefront of Trust and Safety ",
    date: "15 March 2024",
    readTime: "8 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        To enhance its safety moderation further, {BRAND.domainLabel} has partnered
        with Modsquad...
      </p>
    ),
    slug: "imprint-modsquad",
  },
  {
    id: 5,
    title:
      "Checkstep as AI moderation who are at the forefront of online safety.",
    date: "20 June 2024",
    readTime: "8 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        {BRAND.domainLabel} has partnered with Checkstep to lead the platform&apos;s
        AI-driven content moderation...
      </p>
    ),
    slug: "imprint-checkstep",
  },
  {
    id: 6,
    title:
      "{BRAND.domainLabel} runs a focus group with 25 under 18s on social media, challenges and rhetoric and views on {BRAND.short}",
    date: "August 2024",
    readTime: "8 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        On 14th August, {BRAND.domainLabel} ran a focus group with 25 teenagers (all
        under 18s) focusing on the...
      </p>
    ),
    slug: "imprint-social",
  },
  {
    id: 7,
    title:
      "{BRAND.domainLabel} runs a focus group at Trinity College and Mansfield College Oxford with freshers and masters students understanding social media impact and views on {BRAND.short}",
    date: "13 October 2024",
    readTime: "8 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        In October 2024, {BRAND.domainLabel} hosted a focus group with first-year and
        master&apos;s students at the...
      </p>
    ),
    slug: "imprint-college",
  },

  {
    id: 8,
    title:
      "{BRAND.domainLabel} introduces a mindful option to social media at the Conduit Club in London drawing support from its members",
    date: "18 November 2024",
    readTime: "20 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        On 3 December, {BRAND.domainLabel} hosted a private event at the Conduit Club
        in London to introduce its new...
      </p>
    ),
    slug: "imprint-mindful",
  },
  {
    id: 9,
    title:
      "BBFC consultation - age related policies and behaviours and use the agreed wording with BBFC ",
    date: "18 December 2024",
    readTime: "40 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        {BRAND.domainLabel} has developed its policies on age-appropriateness in
        consultation with the UK's...
      </p>
    ),
    slug: "imprint-bbfc",
  },

  {
    id: 10,
    title: "{BRAND.domainLabel} meets with Sir Jeremy Wright MP",
    date: "3 March 2025",
    readTime: "12 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        On 3 March 2025, co-founders of {BRAND.domainLabel}, Andrew and Harleen
        Ahluwalia-Cook, met with Sir...
      </p>
    ),
    slug: "imprint-jeremywright",
  },
  {
    id: 11,
    title:
      "{BRAND.domainLabel} premiers alongside The Unfollow series of graphic novels at London Book Fair ",
    date: "18 March 2025",
    readTime: "40 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        The London Book Fair 2025 saw {BRAND.domainLabel} unveiled to book lovers,
        alongside the launch of the...
      </p>
    ),
    slug: "imprint-books",
  },
  {
    id: 12,
    title:
      "{BRAND.domainLabel} meets with Max Wilkinson MP and Emily Darlington MP to discuss online safety",
    date: "May 2025",
    readTime: "12 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        In May 2025, {BRAND.domainLabel} continued its engagement with political
        stakeholders in the UK to discuss the...
      </p>
    ),
    slug: "imprint-maxwilkinson",
  },
  {
    id: 13,
    title:
      "{BRAND.short} onboards its largest tranche of waitlist users - Press release May 2025 already in place",
    date: "18 May 2025",
    readTime: "3 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        {BRAND.domainLabel} is celebrating its mindful mission during Mental Health
        Month by moving to scale up. The...
      </p>
    ),
    slug: "imprint-users",
  },
  {
    id: 14,
    title: "{BRAND.short} Roundtable press release June 2025",
    date: "13 June 2025",
    readTime: "9 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        On 13 June, {BRAND.domainLabel} hosted a roundtable with mental health experts
        to discuss the platform's...
      </p>
    ),
    slug: "imprint-roundtable",
  },
  {
    id: 15,
    title:
      "{BRAND.short} picks its 18 charities that users will be able to vote for against each value",
    date: "19 June 2025",
    readTime: "6 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        As a values-driven network, {BRAND.domainLabel} empowers users to have a direct
        say in where a portion of...
      </p>
    ),
    slug: "imprint-charities",
  },
  {
    id: 16,
    title:
      "{BRAND.product} partners with Yoti on digital ID protection and age verification making Yoti an exclusive and pre requirement to joining {BRAND.domainLabel}",
    date: "1st July 2025",
    readTime: "16 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        {BRAND.domainLabel} is pleased to announce that the platform has partnered with
        Yoti for digital ID...
      </p>
    ),
    slug: "imprint-yoti",
  },
  {
    id: 17,
    title:
      "{BRAND.domainLabel} meets with Dame Chi Onwurah MP to discuss online safety.",
    date: "1 July 2025",
    readTime: "10 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        On 1 July 2025, {BRAND.domainLabel} met with Dame Chi Onwurah MP, Chair of the
        Science and...
      </p>
    ),
    slug: "imprint-damechionwurah",
  },
  {
    id: 18,
    title:
      "{BRAND.domainLabel} Hosts Roundtable with Mental Health Experts to Advance Online Safeguarding and User Wellbeing in social media networks",
    date: "25 June 2025",
    readTime: "1 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        {BRAND.domainLabel}, a social media platform at the forefront of online safety
        and user wellbeing...
      </p>
    ),
    slug: "imprint-wellbeing",
  },
  {
    id: 19,
    title: "Mental Health Innovations Audit.",
    date: "June 2025",
    readTime: "20 mins read",
    category: "News",
    image: "/Images/news.png",
    description: (
      <p>
        {BRAND.domainLabel} is proud to announce that it has consulted Mental Health
        Innovations (MHI)...
      </p>
    ),
    slug: "imprint-audit",
  },
];

const categories = ["All", "Business", "News", "Others"];

const News = () => {
  const [filter, setFilter] = useState("All");
  const [sortOrder, setSortOrder] = useState("Newest");

  const parseNewsDate = (value) => {
    if (!value) return 0;
    const normalized = String(value).replace(/(\d+)(st|nd|rd|th)/gi, "$1").trim();

    const direct = new Date(normalized);
    if (!Number.isNaN(direct.getTime())) return direct.getTime();

    // Fallback for month-year strings like "June 2025"
    const monthYear = new Date(`1 ${normalized}`);
    if (!Number.isNaN(monthYear.getTime())) return monthYear.getTime();

    return 0;
  };

  const filteredBlogs = NewsData.filter(
    (blog) => filter === "All" || blog.category === filter
  ).sort((a, b) => {
    const aDate = parseNewsDate(a.date);
    const bDate = parseNewsDate(b.date);
    return sortOrder === "Oldest" ? aDate - bDate : bDate - aDate;
  });

  return (
    <MainLayout>
      <div
        id="herobanner"
        style={{
          background: `url(${bannerImage3}) no-repeat top center/cover`,
        }}
      >
        <div className={styles.heroBanner}>
          <div className={styles.overlay}>
            <h1>
              {BRAND.short} <span className={styles.highlight}>News</span>
            </h1>
          </div>
        </div>
      </div>

      <div className={styles.blogPage}>
        <div className={styles.filters}>
          <div className={styles.categories}>
            {categories.map((cat) => (
              <Button
                key={cat}
                type={filter === cat ? "primary" : "default"}
                onClick={() => setFilter(cat)}
              >
                {cat}
              </Button>
            ))}
          </div>
          <div className={styles.sortDropdown}>
            <label>Sort by: </label>
            <Select
              value={sortOrder}
              onChange={(value) => setSortOrder(value)}
              style={{ width: 120 }}
              options={[
                { label: "Oldest", value: "Oldest" },
                { label: "Newest", value: "Newest" },
              ]}
            />
          </div>
        </div>

        <Row gutter={[24, 24]} className={styles.blogList}>
          {filteredBlogs.map((blog) => (
            <Col key={blog.id} xs={24} sm={24} md={12} lg={8} xl={6}>
              <a
                href={`/news/${blog.slug}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.blogCardLink}
              >
                <div className={styles.blogCard}>
                  <div
                    className={styles.image}
                    style={{ backgroundImage: `url(${blog.image})` }}
                  >
                    <Tag className={styles.categoryTag} color="blue">
                      {blog.category}
                    </Tag>
                  </div>
                  <div className={styles.content}>
                    <p className={styles.meta}>
                      {blog.date} • {blog.readTime}
                    </p>
                    <h3>{blog.title}</h3>
                    <p className={styles.description}>{blog.description}</p>
                  </div>
                </div>
              </a>
            </Col>
          ))}
        </Row>
      </div>
    </MainLayout>
  );
};

export default News;
